import { CircularProgress, Dialog } from "@material-ui/core";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { DropdownIcon } from "../../../../assets/Icons";
import Button from "../../../../components/ui/Button";
import { getTransactionSummary } from "../../../../services/offline";
import { offlineWesternUnion } from "../../../../store";
import { receivingCountryData } from "../../../../utils";
import { customAlert } from "../../../../utils/CustomAlert";
import { PaymentDetails } from "./PaymentDetails";

const OfflineWURemittance = () => {
  const navigate = useNavigate();
  const [offlineWUData, setOfflineWUData] = useRecoilState(offlineWesternUnion);
  const [amount, setAmount] = React.useState<any>(10000);
  const [rate, setRate] = React.useState<any>();
  const [receivingAmount, setReceivingAmount] = React.useState<any>(0.0);
  const [receivingSetAmount, setReceivingSetAmount] = React.useState<any>(0);
  const [nostro, setNostro] = React.useState<string>("our");
  const [reference, setReference] = React.useState<string>("");
  const [vendorFees, setVendorFees] = React.useState<any>(0);
  const [currencyName, setCurrencyName] = React.useState("USD");
  const [isModalOpen, setIsModalOpen] = React.useState("");
  const [pan, setPan] = React.useState<string>("");
  const [correctResponse, setCorrectResponse] = React.useState<boolean>(false);
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const [receiveAmount, setReceiveAmount] = useState(0);
  const [sendAmount, setSendAmount] = React.useState<any>(0);
  const specialCharRegExp = "[a-zA-Z0-9 ]{1,}";
  const newSendMoney = parseInt(sendAmount) + parseInt(vendorFees);

  useEffect(() => {
    rate && receiveAmount && setSendAmount(receiveAmount * rate);
  }, [rate, receiveAmount, vendorFees]);

  useEffect(() => {
    setAmount("");
    setReference("");
    setVendorFees(0);
  }, []);
  useEffect(() => {
    setOfflineWUData({
      ...offlineWUData,
      reference: reference,
    });
    const body = nostro === "our" ? { isBene: false } : nostro === "bene" && { isBene: true };
    const delayDebounce = setTimeout(() => {
      // if (receiveAmount && rate && reference && vendorFees)
      if (sendAmount > 0 && rate > 0) {
        getTransactionSummary({
          ...body,
          user_send: receiveAmount * rate + parseFloat(vendorFees),
          // reciepient_recieve: amount * rate,
          conversion_rate: rate,
          dest_currency: currencyName,
          // reference: reference,
          vendor_key: currentUser.vendor_key,
          purposeCode: "S0305",
          isEducation: true,
          transaction_purpose: "Overseas Education - University Fees",
          vendorFee: vendorFees,
          modeOfTransaction: "WesternUnion",
          base_currency: "INR",
        })
          .then((response: any) => {
            setCorrectResponse(true);
            setOfflineWUData({
              ...response?.data,
            });
          })
          .catch((error) => {
            customAlert(error.response.data.error.type);
            //something
          });
      }
    }, 1000);

    return () => clearTimeout(delayDebounce);
  }, [receiveAmount, rate, currencyName, reference, vendorFees, nostro, sendAmount]);

  const proceedClick = () => {
    setOfflineWUData({
      ...offlineWUData,
      amount: amount,
      rate: rate,
      reference: reference,
      vendorFees: vendorFees,
    });
    navigate("/2/remitter");
  };
  return (
    <div
      id="paymentOverview"
      className="flex flex-col justify-center w-full mt-20 ml-20 transition-all"
    >
      <div className="flex items-center justify-center w-full space-x-20 transition-all rounded">
        <div className="flex flex-col w-[600px] transition-all">
          <div id="youSend" className="flex flex-col justify-center">
            <span className="font-semibold text-[19px]">They Receive</span>
            <div className="flex items-center my-3">
              {/* <DebounceInput
                minLength={2}
                className="w-full rounded-md p-[3.4%] bg-blue-100 text-lg outline-none"
                name="sendingAmount"
                type="number"
                placeholder={"Enter Amount"}
                maxLength={7}
                value={amount}
                debounceTimeout={1000}
                onChange={(e: any) => setAmount(e.target.value)}
              /> */}
              <input
                placeholder="Enter Receiving Amount"
                className="w-full rounded-md p-[3.4%] bg-blue-100 text-lg outline-none"
                value={receiveAmount}
                onChange={(e: any) => setReceiveAmount(e.target.value)}
                pattern={specialCharRegExp}
                type="number"
              />

              {/* <div className="flex py-[17px] w-[155px] space-x-4 border rounded-md cursor-pointer">
                <img
                  src={`/images/png/INR.png`}
                  alt="country-image"
                  className="rounded-[200px] w-7 h-7 ml-5"
                />
                <span className="bg-white text-[19px]">{"INR"}</span>
              </div> */}
              <div
                onClick={() => setIsModalOpen("recieve")}
                className="flex py-[17px] w-[155px] space-x-4 border rounded-md cursor-pointer"
              >
                <img
                  src={`/images/png/${currencyName}.png`}
                  alt="receiving-country-image"
                  className="rounded-[200px] w-7 h-7 ml-3"
                />
                <span className="bg-white text-[19px] space-x-2 flex items-center">
                  <span className="-ml-2">{currencyName}</span>
                  <DropdownIcon />
                </span>
              </div>
            </div>
          </div>
          <div className="flex flex-col justify-center space-y-3">
            <span className="text-[19px] font-semibold">Conversion Rate</span>
            <input
              placeholder="Enter Rate"
              value={rate}
              type="number"
              onChange={(e: any) => setRate(e.target.value)}
              className="w-full rounded-md p-[3.4%] bg-blue-100 text-lg outline-none"
              pattern={specialCharRegExp}
            />
          </div>
          <div id="amount" className="flex flex-col justify-center mt-3">
            <div className="flex items-center space-x-3">
              <span className="text-[19px] font-semibold">You Send</span>
              {/* <span className="text-[15px] font-bold text-blue-400">
                (Inclusive of Vendor Fees)
              </span> */}
            </div>
            <div className="flex my-3">
              {/* <DebounceInput
                placeholder={"They Receive"}
                minLength={2}
                className="w-full rounded-l-md p-[3.4%] bg-blue-100 text-lg outline-none"
                name="recievingAmount"
                type="number"
                value={receivingSetAmount}
                //   value={recievingAmount}
                //   disabled={recieveDisabled}
                onChange={(e: any) => {
                  setReceivingAmount(e.target.value);
                }}
              /> */}
              <input
                placeholder="Enter Receiving Amount"
                className="w-full rounded-md p-[3.4%] bg-blue-100 text-lg outline-none"
                value={newSendMoney}
                onChange={(e: any) => setSendAmount(e.target.value)}
                pattern={specialCharRegExp}
                type="number"
              />
              {/* <div
                onClick={() => setIsModalOpen("recieve")}
                className="flex py-[17px] w-[155px] space-x-4 border rounded-md cursor-pointer"
              >
                <img
                  src={`/images/png/${currencyName}.png`}
                  alt="receiving-country-image"
                  className="rounded-[200px] w-7 h-7 ml-3"
                />
                <span className="bg-white text-[19px] space-x-2 flex items-center">
                  <span className="-ml-2">{currencyName}</span>
                  <DropdownIcon />
                </span>
              </div> */}
              <div className="flex py-[17px] w-[155px] space-x-4 border rounded-md cursor-pointer">
                <img
                  src={`/images/png/INR.png`}
                  alt="country-image"
                  className="rounded-[200px] w-7 h-7 ml-5"
                />
                <span className="bg-white text-[19px]">{"INR"}</span>
              </div>
            </div>
          </div>
          <div className="flex flex-col justify-center space-y-3">
            <span className="text-[19px] font-semibold">Reference</span>
            <input
              placeholder="Enter Reference"
              value={reference}
              onChange={(e: any) => setReference(e.target.value)}
              className="w-full rounded-md p-[3.4%] bg-blue-100 text-lg outline-none"
              autoComplete="off"
              pattern={specialCharRegExp}
            />
          </div>
          <div className="flex flex-col justify-center space-y-3">
            <span className="text-[19px] font-semibold">Vendor Fees</span>
            <input
              placeholder="Enter Vendor Fees"
              value={vendorFees}
              onChange={(e: any) => setVendorFees(e.target.value)}
              className="w-full rounded-md p-[3.4%] bg-blue-100 text-lg outline-none"
              pattern={specialCharRegExp}
              type="number"
            />
          </div>
        </div>
        <div className="w-1 h-[600px] border-gray-300 border-r-2 transition-all"></div>
        <div className="w-[600px] transition-all relative">
          {!correctResponse && (
            <div className="absolute z-50 w-[560px] h-[650px] -ml-[40px] mt-[75px] bg-gray-500 opacity-80 rounded-xl flex items-center justify-center">
              <span className="text-white font-bold text-[32px] flex items-center space-x-5">
                <div>
                  <CircularProgress />
                </div>
                <div className="mb-3 text-[18px]">Fill in the details to see the calculations</div>
              </span>
            </div>
          )}
          <PaymentDetails
            amount={amount}
            rate={rate}
            recievingAmount={receivingAmount}
            nostro={nostro}
            setNostro={setNostro}
            handlePanBasedClick={() => undefined}
            setIsModalOpen={setIsModalOpen}
            setPan={setPan}
            pan={pan}
            sendAmount={sendAmount}
          />
        </div>
      </div>
      <div id="submit" className="flex justify-center">
        <Button
          bgColor={clsx(!vendorFees ? "bg-gray-500" : "bg-primary-1050")}
          fontStyle={{
            fontFamily: "font-roboto",
            fontSize: "text-base",
            fontWeight: "font-bold",
            fontColor: "text-white",
          }}
          borderStyle={{
            borderRadius: "rounded",
          }}
          onClickHandler={proceedClick}
          className={clsx(
            !vendorFees
              ? "flex justify-center py-4 mt-6 ml-5 px-14"
              : "flex justify-center py-4 mt-6 ml-5 px-14 hover:scale-105 transition-all"
          )}
          disabled={!vendorFees}
        >
          Proceed
        </Button>
      </div>
      <Dialog open={isModalOpen === "recieve"} onClose={() => setIsModalOpen("")}>
        <div className="px-8 py-3 font-bold text-white bg-primary">Select Destination Currency</div>
        <div className="pt-4 px-7 lg:px-9">
          <div className="h-12 lg:border-none w-[372px] lg:w-[404px] mb-9"></div>
          <div className="lg:mx-[68px] -mt-20">
            {receivingCountryData.map((data, index) => {
              return (
                <div
                  className="flex items-center justify-between w-full py-6 border-b cursor-pointer lg:mb-11 lg:border-none lg:py-0 border-grey-1000"
                  key={index}
                  onClick={() => {
                    setCurrencyName(data.currencyName);
                    setOfflineWUData({
                      ...offlineWUData,
                      currency: data.currencyName,
                    });
                    setIsModalOpen("");
                  }}
                >
                  <div className="mr-8 text-xl font-normal text-primary-650">
                    {data.currencyName}
                  </div>
                  <div className="flex items-center w-2/6">
                    <div className="flex items-center justify-center w-8 h-8 mr-5">
                      <img
                        src={`/images/png/${data.currencyName}.png`}
                        alt="country-image"
                        className="rounded-[200px] w-full h-full"
                      />
                    </div>
                    <div className="text-xl font-bold text-left text-primary-650 justify-items-start">
                      {data.currencyName}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default OfflineWURemittance;
